// src/platform/PlatformDatasetsPage.jsx
import { useEffect, useState } from "react";
import { Database } from "lucide-react";
import { DatasetsTable } from "./components/DatasetsTable";
import { useDatasetsStore } from "../stores/useDatasetsStore";

export default function PlatformDatasetsPage() {
    const datasets = useDatasetsStore(s => s.datasets);
    const loading = useDatasetsStore(s => s.loading);
    const loadDatasets = useDatasetsStore(s => s.loadDatasets);
    const warmDataset = useDatasetsStore(s => s.warmDataset);
    const warming = useDatasetsStore(s => s.warming);

    useEffect(() => {
        loadDatasets();
    }, [loadDatasets]);

    return (
        <div className="h-full flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-bg-border">
                <div className="flex items-center gap-3">
                    <Database className="w-5 h-5 text-accent-action" />
                    <h1 className="text-lg font-semibold">Datasets</h1>
                </div>

                {/* Future */}
                <button
                    disabled
                    className="opacity-50 cursor-not-allowed text-sm px-3 py-1.5 rounded bg-bg-soft border border-bg-border"
                >
                    + New Dataset
                </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-auto px-6 py-4">
                {loading ? (
                    <div className="text-sm text-muted">Loading datasets…</div>
                ) : (
                    <DatasetsTable
                        datasets={datasets}
                        warming={warming}
                        onWarm={ds => warmDataset(ds.dataset_key)}
                    />)}
            </div>
        </div>
    );
}